<template>
  <BaseModal id="label-creation" :value="value" @input="changeStatus">
    <h1>Close Return</h1>
    <BaseForm ref="form" @submit="submitForm">
      <BaseTextField
        v-model="refundedAmount"
        type="number"
        step="0.01"
        label="Amount refunded"
        required
      />
      <BaseTextField
        v-model="newResolution"
        type="text"
        label="Resolution"
        required
      />
      <template v-slot:actions>
        <div class="flex flex-row gap-2">
          <button class="btn-success-button">
            <span v-if="!loading">Save</span>
            <base-mini-spinner v-else></base-mini-spinner>
          </button>
          <button
            class="btn-dark-button"
            type="button"
            @click="changeStatus(false)"
          >
            close
          </button>
        </div>
      </template>
    </BaseForm>
  </BaseModal>
</template>
<script>
import { completeReturn } from "@/api/store/ReturnsService.js";
export default {
  name: "CloseReturnModal",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    estimatedRefund: {
      type: Number,
      required: true
    },
    returnShipmentPaidBy: {
      type: String,
      required: true
    },
    currentStatus: {
      type: String,
      required: true
    },
    resolution: {
      type: String,
      required: true
    },
    returnId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      paidByOptions: [
        {
          name: "Customer",
          code: "Customer"
        },
        {
          name: "NKR DIESEL PARTS",
          code: "NKR DIESEL PARTS"
        }
      ],
      resolutionOptions: [
        {
          name: "Refund",
          code: "Refund"
        },
        {
          name: "Replaced",
          code: "Replaced"
        },
        {
          name: "Partially refunded",
          code: "Partially refunded"
        },
        {
          name: "Refunded without shipping",
          code: "Refunded without shipping"
        }
      ],
      newReturnShipmentPaidBy: this.returnShipmentPaidBy,
      refundedAmount: this.estimatedRefund,
      newResolution: this.resolution
    };
  },
  methods: {
    changeStatus(newStatus) {
      if (this.loading) return;
      this.$emit("input", newStatus);
    },
    async submitForm() {
      if (this.validate()) {
        this.loading = true;
        try {
          await completeReturn(
            this.returnId,
            this.refundedAmount,
            this.currentStatus,
            this.newResolution
          );
          this.$toast.open({
            message: `Return completed.`,
            type: "success",
            position: "top-right"
          });
          this.loading = false;
          this.changeStatus(false);
          this.$emit("updatedReturn");
        } catch (error) {
          this.$toast.open({
            message: `Error completing return.`,
            type: "error",
            position: "top-right"
          });
          console.log(error);
          this.loading = false;
          this.$refs.form.addError("Error completing return");
        }
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        return true;
      }
      this.$toast.open({
        message: `Please fill the form.`,
        type: "error",
        position: "top-right"
      });
      return false;
    }
  }
};
</script>
